import {
    CalendarToday,
    Dashboard,
    Work,
    AssignmentTurnedIn,
    Settings,
    BarChart,
} from "@material-ui/icons"

// const sideRoutes = [
//     { name: "Panel de Control", icon: Dashboard, link: "/panel" },
//     {
//         name: "Empresa",
//         icon: Work,
//         link: "/enterprise",
//         subroutes: [
//             { name: "Datos Empresa", link: "/enterprise" },
//             { name: "Documentos", link: "/enterprise/documents" },
//             { name: "Colaboradores", link: "/workers" },
//         ],
//     },
//     {
//         name: "Módulos",
//         icon: AssignmentTurnedIn,
//         link: "/risks",
//         subroutes: [
//             { name: "Planificación Actividades", link: "/activities" },
//             { name: "Listas de Chequeo", link: "/checklists" },
//             { name: "Hallazgos", link: "/findings" },
//             { name: "No Conformidades", link: "/unconformities" },
//             { name: "Charlas", link: "/talks" },
//             { name: "Capacitaciones", link: "/trainings" },
//             { name: "IPER", link: "/iper" },
//         ],
//     },
//     { name: "Calendario", icon: CalendarToday, link: "/calendar" },
//     {
//         name: "Configuración", icon: Settings, subroutes: [
//             { name: "Listas de Chequeo", link: "/settings/checklists" },
//             { name: "Actividades", link: "/settings/activities" },
//             { name: "Charlas", link: "/settings/talks" },
//             { name: "Capacitaciones", link: "/settings/trainings" },
//             { name: "Documentos Colaboradores", link: "/settings/users/documents" },
//             { name: "Documentos Empresa", link: "/settings/enterprise/documents" },
//         ]
//     },
//     { name: "Reportes", icon: BarChart, link: "/reports" },
// ]

const sideRoutes = {
    1: [
        { name: "Panel de Control", icon: Dashboard, link: "/panel" },
        {
            name: "Empresa",
            icon: Work,
            link: "/enterprise",
            subroutes: [
                { name: "Datos Empresa", link: "/enterprise" },
                { name: "Centros de trabajo", link: "/branches" },
                { name: "Documentos", link: "/enterprise/documents" },
                { name: "Colaboradores", link: "/workers" },
            ],
        },
        {
            name: "Módulos",
            icon: AssignmentTurnedIn,
            link: "/risks",
            subroutes: [
                { name: "Planificación Actividades", link: "/activities" },
                { name: "Listas de Chequeo", link: "/checklists" },
                { name: "Hallazgos", link: "/findings" },
                { name: "No Conformidades", link: "/unconformities" },
                { name: "Charlas", link: "/talks" },
                { name: "Capacitaciones", link: "/trainings" },
                { name: "Procesos", link: "/workflows" },
                { name: "IPER", link: "/iper" },
            ],
        },
        { name: "Calendario", icon: CalendarToday, link: "/calendar" },
        {
            name: "Configuración", icon: Settings, subroutes: [
                { name: "Listas de Chequeo", link: "/settings/checklists" },
                { name: "Actividades", link: "/settings/activities" },
                { name: "Charlas", link: "/settings/talks" },
                { name: "Capacitaciones", link: "/settings/trainings" },
                { name: "Documentos Colaboradores", link: "/settings/users/documents" },
                { name: "Documentos Empresa", link: "/settings/enterprise/documents" },
                { name: "Contratistas", link: "/settings/sub_branches" },
                { name: "Procesos", link: "/settings/processes" },
            ]
        },
        {
            name: "Reportes", icon: BarChart, subroutes: [
                { name: "Hallazgos", link: "/reports/findings" },
                { name: "Actividades", link: "/reports/activities" }
            ]
        },
    ],
    2: [
        { name: "Panel de Control", icon: Dashboard, link: "/panel" },
        {
            name: "Empresa",
            icon: Work,
            link: "/enterprise",
            subroutes: [
                { name: "Datos Empresa", link: "/enterprise" },
                { name: "Documentos", link: "/enterprise/documents" },
                { name: "Colaboradores", link: "/workers" },
            ],
        },
        {
            name: "Módulos",
            icon: AssignmentTurnedIn,
            link: "/risks",
            subroutes: [
                { name: "Listas de Chequeo", link: "/checklists" },
                { name: "Hallazgos", link: "/findings" },
                { name: "No Conformidades", link: "/unconformities" },
                { name: "Charlas", link: "/talks" },
                { name: "Capacitaciones", link: "/trainings" },
            ],
        },
        { name: "Calendario", icon: CalendarToday, link: "/calendar" },
    ],
    3: [
        { name: "Panel de Control", icon: Dashboard, link: "/panel" },
        {
            name: "Empresa",
            icon: Work,
            link: "/enterprise",
            subroutes: [
                { name: "Documentos", link: "/enterprise/documents" },
            ],
        },
        {
            name: "Módulos",
            icon: AssignmentTurnedIn,
            link: "/risks",
            subroutes: [
                { name: "Listas de Chequeo", link: "/checklists" },
                { name: "Hallazgos", link: "/findings" },
                { name: "No Conformidades", link: "/unconformities" },
                { name: "Charlas", link: "/talks" },
                { name: "Capacitaciones", link: "/trainings" },
            ],
        },
        { name: "Calendario", icon: CalendarToday, link: "/calendar" },
    ],
    4: [
        { name: "Panel de Control", icon: Dashboard, link: "/panel" },
        {
            name: "Módulos",
            icon: AssignmentTurnedIn,
            link: "/risks",
            subroutes: [
                { name: "Listas de Chequeo", link: "/checklists" },
                { name: "Hallazgos", link: "/findings" },
                { name: "No Conformidades", link: "/unconformities" },
                { name: "Charlas", link: "/talks" },
                { name: "Capacitaciones", link: "/trainings" },
            ],
        },
        { name: "Calendario", icon: CalendarToday, link: "/calendar" },
    ]
}

export default sideRoutes
